import CookieBar from "./Cookiebar";

export default CookieBar
